import script from "./ChannelsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelsModal.vue?vue&type=script&setup=true&lang=js"

import "./ChannelsModal.vue?vue&type=style&index=0&id=fdb12a96&lang=scss"

const __exports__ = script;

export default __exports__